import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { GENERATION_PORTAL_ID, GENERATION_PORTAL_ID_QA, INTERNAL_PORTAL_ID, INTERNAL_PORTAL_ID_QA } from '../accountsConstants';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const isInternalPortal = (portalId = PortalIdParser.getPortalIdFromPath()) => portalId === (enviro.isQa() ? INTERNAL_PORTAL_ID_QA : INTERNAL_PORTAL_ID);
export const isGenerationPortal = (portalId = PortalIdParser.getPortalIdFromPath()) => portalId === (enviro.isQa() ? GENERATION_PORTAL_ID_QA : GENERATION_PORTAL_ID);
export const ExternalPortalOnly = ({
  portalId = PortalIdParser.getPortalIdFromPath(),
  fallback,
  children
}) => {
  const isInternalOrGenerationPortal = isInternalPortal(portalId) || isGenerationPortal(portalId);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isInternalOrGenerationPortal ? fallback : children
  });
};
export default ExternalPortalOnly;